import React, { useEffect, useState } from "react";
import axios from "axios";
import Banner from "./Banner";
// import Category from "./Category";
import Category from "./component/Category";

const Home = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const publicUrl = process.env.PUBLIC_URL;
  const [bannerData, setBannerData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);

  useEffect(() => {
    fetchBannerData();
    fetchCategoryData();
  }, [apiBaseUrl, publicUrl]);

  const fetchBannerData = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/banners/GetActiveBanners`);
      let banners = response.data
        .map((banner) => ({
          ...banner,
          imageSource: `${publicUrl}/${banner.imageSource}`,
        }));

      setBannerData(banners);
    } catch (error) {
      console.error("There was an error fetching the banner data!", error);
    }
  };

  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/categories/GetActiveParentCategories`);
      let categories = response.data.map((category) => ({
        ...category,
        imageSource: `${publicUrl}/${category.imageSource}`,
      }));;
      setCategoryData(categories);
    } catch (error) {
      console.error("There was an error fetching the category data!", error);
    }
  };

  return (
    <>
      <Banner bannerData={bannerData} />
      <Category categoryData={categoryData}></Category>
    </>
  );
};

export default Home;
